<docs>
# Select

> NOTE: this docs defined at **docs** section inside Select.vue module

<!-- STORY -->

### Example

>Single

```html
<mt-select name="default-select" options="options">Direction right</mt-select>
```

```javascript
export default {
  data() {
    return {
      options: [
        {
          value: 'Option1',
          label: 'Option1'
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        }
      ],
    }
  }
}
```

#### Props

| Property | Description              | Type     | Accepted Values       | Default |
|----------|--------------------------|----------|-----------------------|---------|
| options  | options       | Array    | [{label: label, value: value}] or [values] | -     |
| name     | name          | String   | - | required    |
| label    | label         | String   | - | -    |
| placeholder | placeholder   | String  | —    | -       |
| caption  | caption   | String   | -   | -     |
| multiple   | wrapper is wrap scrolled box | String | only id '#wrapper' | window     |
| clearble | whether value is clearble  | Boolean  | -    | false    |
| disabled | whether input is disabled  | Boolean  | -    | false     |
| width    | width  | Number  | -    | 240    |
| autoFilter | when input value, Options would be filtered  | Boolean  | -    | false    |

### Events

| Name         | Description                       | Parameters   |
|--------------|-----------------------------------|--------------|
| change       | fire when checked value changed.  | value, event |
| clickIcon    | fire when click icon.             | value, event |

</docs>
<template>
  <div
    class="mt-select mt-font--body10 mt--neutrals-dark-gray-02"
    :class="isDropdown ? 'mt-select--open' : ''"
    :style="{width: width+'px'}">
    <mt-input
      @click="handleClickIcon"
      :value.sync="selectedValue" :label="label"
      name="icon" :placeholder="placeholder" :disabled="disabled"  icon="chevron-down" :clearble="clearble"/>
    <ul
      class="mt-select__options mt-font--body10" :style="optionStyles">
      <li
        v-for="(item, index) in filteredOptions" :key="index"
        @click="handleClickOption(item)"
        class="mt--neutrals-dark-gray-02"
        :class="{'selected': getValueOfItem(item) === selectedValue}">
        {{getLabelOfItem(item)}}
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'mt-select',
  provide() {
    const selectOption = {}
    Object.defineProperty(selectOption, 'focusable', {
       enumerable: true,
       get: () => this.focusable,
    })
    return {selectOption}
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    label: {
      type: String,
    },
    options: {
      type: Array,
      default: function(){ return [] }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String
    },
    width: {
      type: Number,
      default: 240
    },
    valid: {
      type: Boolean,
      default: true
    },
    inValidMsg: {
      type: String,
      default: 'not valid'
    },
    clearble: {
      type: Boolean,
      default: false
    },
    autoFilter: {
      type: Boolean,
      default: false
    }
  },
  components: {

  },
  data () {
    return {
      selectedValue: '',
      isDropdown: false,
    }
  },
  computed: {
    optionStyles(){
      let styles = {width: this.width+'px', top: '48px'}
      if(this.label) styles.top = '69px'
      return styles
    },
    focusable(){
      let focusable = false
      if(this.autoFilter) focusable = true
      return focusable
    },
    filteredOptions(){
      if(!this.autoFilter) return this.options
      let options = this.options.filter(option => {
        if(['string', 'number'].includes(typeof option)){
          return option.indexOf(this.selectedValue) !== -1
        }else{
          return option.label.indexOf(this.selectedValue) !== -1 || option.value.indexOf(this.selectedValue) !== -1
        }
      })
      return options
    }
  },

  methods: {
    handleClickIcon(event){
      this.isDropdown = !this.isDropdown
    },
    getValueOfItem(item){
      return ['string', 'number'].includes(typeof item) ? item : item.value
    },
    getLabelOfItem(item){
      return ['string', 'number'].includes(typeof item) ? item : item.label
    },
    handleClickOption(targetItem){
      this.selectedValue = this.getValueOfItem(targetItem)
      this.isDropdown = false
    }
  },


}
</script>

<style lang="scss">
@import "../styles/Variables";

$module: 'mt-select';

.#{$module} {
  position: relative;
  select {
    padding: 7px 8px 7px 16px;
    line-height: 22px;
  }
  input {
    cursor: pointer;
  }
  &__options {
    position: absolute;
    z-index: 1;
    visibility: hidden;
    opacity: 0;
    top: 48px;
    left: 0;
    list-style: none;
    padding: 6px 1px 6px 0;
    margin: 0;
    max-height: 250px;
    overflow: scroll;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);
    background-color: $c-white;
    border: solid 0.5px rgba(178, 192, 208, 0.7);
    transition:visibility 0.5s, opacity 0.2s linear;
    transform: rotate(0);
    li {
      padding: 7px 8px 7px 16px;
      cursor: pointer;
      &:hover { background-color: $c-neutrals-light-gray-01; }
      &.selected { color: #097db7; }
    }
  }
  .mt-input__icon {
    transition:transform .7s;
  }
}

.#{$module}--open {
  .#{$module}__options {
    visibility: visible;
    opacity: 1;
  }
  .mt-input__icon {
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// Select.vue?67749a56